const selectorsWarranty = {
  MODAL_WARRANTY_SELECTOR: ".js-modal-warranty",
  CLOSE_MODAL_SELECTOR: ".js-close-modal",
  OPEN_MODAL_SELECTOR: ".js-open-modal",
  ACTIVE_CLASS: "active"
};

class ModalWarranry extends HTMLElement {
  constructor() {
    super();

    this.modalWrrantyEl = this.closest(
      selectorsWarranty.MODAL_WARRANTY_SELECTOR
    );
    this.closeModalEls = this.modalWrrantyEl.querySelectorAll(
      selectorsWarranty.CLOSE_MODAL_SELECTOR
    );
    this.openModalEl = document.querySelector(
      selectorsWarranty.OPEN_MODAL_SELECTOR
    );
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openModalEl &&
      this.openModalEl.addEventListener("click", () => {
        this.modalWrrantyEl &&
          this.modalWrrantyEl.classList.add(selectorsWarranty.ACTIVE_CLASS);
      });

    if (this.closeModalEls.length) {
      this.closeModalEls.forEach((closeEl) => {
        closeEl.addEventListener("click", () => {
          this.modalWrrantyEl &&
            this.modalWrrantyEl.classList.remove(
              selectorsWarranty.ACTIVE_CLASS
            );
        });
      });
    }

    window.addEventListener("keydown", (event) => {
      if (event.keyCode === 27) {
        this.modalWrrantyEl &&
          this.modalWrrantyEl.classList.remove(selectorsWarranty.ACTIVE_CLASS);
      }
    });
  }
}

if (!customElements.get("modal-warranty")) {
  customElements.define("modal-warranty", ModalWarranry);
}
